module.exports = __webpack_public_path__ + "img/A58A2064.6d8e0956.jpg";